import { sumBy } from "lodash";
import { AICC_SANDBOX_LIMITS } from "constants/aiccPromptSandbox";
import { AiccSandboxTurn } from "types/model/aiccPromptSandbox";

export interface SandboxLimitState {
  isBlocked: boolean;
  isNear: boolean;
  turns: number;
  characters: number;
  /**
   * How much room is left, which is the half an operator can act on — the ceiling itself leaves them
   * to subtract. Both units, because the panel speaks rounds where a wrap-up applies and turns where
   * one does not: lesson review reports `roundCount: 0` on every turn, so a round there would be a
   * number describing nothing.
   */
  turnsLeft: number;
  roundsLeft: number;
}

const NEAR_TURNS = 4;

const NEAR_CHARACTERS = 4000;

// 🔴 The backend refuses rather than truncates, so the panel stops the conversation before it does.
export function sandboxRequestLimits(transcript: AiccSandboxTurn[]): SandboxLimitState {
  const turns = transcript.length;
  const characters = sumBy(transcript, ({ content }) => content.length);

  const isBlocked = turns >= AICC_SANDBOX_LIMITS.transcriptTurns || characters >= AICC_SANDBOX_LIMITS.transcriptChars;
  const isNear =
    turns >= AICC_SANDBOX_LIMITS.transcriptTurns - NEAR_TURNS ||
    characters >= AICC_SANDBOX_LIMITS.transcriptChars - NEAR_CHARACTERS;

  // Floored at zero: a blocked conversation has no room left, and a negative count would render as
  // "room for about -2 more rounds" on the one message that has to be plain.
  const turnsLeft = Math.max(0, AICC_SANDBOX_LIMITS.transcriptTurns - turns);

  return {
    isBlocked,
    isNear: !isBlocked && isNear,
    turns,
    characters,
    turnsLeft,
    roundsLeft: Math.floor(turnsLeft / AICC_SANDBOX_LIMITS.turnsPerRound),
  };
}
